import React, { PureComponent } from 'react';
import Compare from './Compare';
import Filter from './Filter';

class Header extends PureComponent {
  render() {
    return (
      <div className="financial-ratio-header d-flex justify-content-between mt-20 flex-shrink-0">
        <Compare />
        <Filter />
      </div>
    );
  }
}

Header.propTypes = {};

export default Header;
